// extracted by mini-css-extract-plugin
module.exports = {"component":"Wysiwyg_component__BctRJ","component__itemContent":"Wysiwyg_component__itemContent__JhG9b"};